(function () {
  'use strict';

  /*
   * Prevent duplicate initialization if this asset
   * is loaded more than once.
   */
  if (window.MisqaProductCard) {
    window.MisqaProductCard.init(document);
    return;
  }

  var hoverQuery = window.matchMedia(
    '(hover: hover) and (pointer: fine)'
  );

  var TRANSITION_DURATION = 520;
  var TRANSITION_EASING =
    'cubic-bezier(0.22, 1, 0.36, 1)';

  function getClosest(element, selector) {
    if (
      !element ||
      typeof element.closest !== 'function'
    ) {
      return null;
    }

    return element.closest(selector);
  }

  function getCard(element) {
    return getClosest(
      element,
      '[data-misqa-product-card]'
    );
  }

  function getSlider(card) {
    if (!card) return null;

    return card.querySelector(
      '[data-product-image-slider]'
    );
  }

  function getSlides(card) {
    if (!card) return [];

    return Array.prototype.slice.call(
      card.querySelectorAll(
        '.misqa-card__img-slide'
      )
    );
  }

  function normaliseIndex(index, length) {
    if (!length) return 0;

    return (index + length) % length;
  }

  function clearSlideStyles(slide) {
    slide.style.removeProperty('opacity');
    slide.style.removeProperty('z-index');
    slide.style.removeProperty(
      'pointer-events'
    );
  }

  function cancelRunningAnimations(slider) {
    if (
      !slider ||
      !slider._misqaAnimations
    ) {
      return;
    }

    slider._misqaAnimations.forEach(
      function (animation) {
        try {
          animation.cancel();
        } catch (error) {
          // Animation may already be completed.
        }
      }
    );

    slider._misqaAnimations = [];
  }

  function setFinalSlideState(
    slider,
    slides,
    activeIndex
  ) {
    cancelRunningAnimations(slider);

    slides.forEach(function (
      slide,
      slideIndex
    ) {
      var isActive =
        slideIndex === activeIndex;

      slide.classList.toggle(
        'is-active',
        isActive
      );

      slide.setAttribute(
        'aria-hidden',
        isActive ? 'false' : 'true'
      );

      clearSlideStyles(slide);
    });

    slider.dataset.visibleIndex =
      String(activeIndex);

    delete slider.dataset.transitionTarget;
  }

  function getVisibleIndex(
    slider,
    slides
  ) {
    var visibleIndex = parseInt(
      slider.dataset.visibleIndex || '',
      10
    );

    if (!Number.isNaN(visibleIndex)) {
      return normaliseIndex(
        visibleIndex,
        slides.length
      );
    }

    var activeIndex = slides.findIndex(
      function (slide) {
        return slide.classList.contains(
          'is-active'
        );
      }
    );

    return activeIndex >= 0
      ? activeIndex
      : 0;
  }

  function showImage(
    card,
    index,
    updateSelectedImage
  ) {
    var slider = getSlider(card);
    var slides = getSlides(card);

    if (!slider || !slides.length) {
      return;
    }

    var nextIndex = normaliseIndex(
      index,
      slides.length
    );

    var currentVisibleIndex =
      getVisibleIndex(slider, slides);

    /*
     * currentIndex stores the permanently
     * selected image.
     *
     * Hover preview does not permanently
     * update currentIndex.
     */
    if (updateSelectedImage !== false) {
      slider.dataset.currentIndex =
        String(nextIndex);
    }

    if (
      nextIndex === currentVisibleIndex
    ) {
      setFinalSlideState(
        slider,
        slides,
        nextIndex
      );

      return;
    }

    /*
     * Finish an existing image transition
     * before starting another transition.
     */
    if (
      slider.dataset.transitionTarget != null
    ) {
      var previousTarget =
        normaliseIndex(
          parseInt(
            slider.dataset.transitionTarget,
            10
          ) || 0,
          slides.length
        );

      setFinalSlideState(
        slider,
        slides,
        previousTarget
      );

      currentVisibleIndex =
        previousTarget;

      if (
        nextIndex === currentVisibleIndex
      ) {
        return;
      }
    }

    var currentSlide =
      slides[currentVisibleIndex];

    var nextSlide =
      slides[nextIndex];

    if (!currentSlide || !nextSlide) {
      return;
    }

    slider.dataset.transitionTarget =
      String(nextIndex);

    slider.dataset.visibleIndex =
      String(nextIndex);

    /*
     * Keep both images active while
     * the crossfade animation runs.
     */
    currentSlide.classList.add(
      'is-active'
    );

    nextSlide.classList.add(
      'is-active'
    );

    currentSlide.setAttribute(
      'aria-hidden',
      'true'
    );

    nextSlide.setAttribute(
      'aria-hidden',
      'false'
    );

    currentSlide.style.zIndex = '2';
    nextSlide.style.zIndex = '3';

    currentSlide.style.pointerEvents =
      'none';

    nextSlide.style.pointerEvents =
      'none';

    /*
     * Browser fallback if Web Animations
     * API is unavailable.
     */
    if (
      typeof currentSlide.animate !==
        'function' ||
      typeof nextSlide.animate !==
        'function'
    ) {
      setFinalSlideState(
        slider,
        slides,
        nextIndex
      );

      return;
    }

    var outgoingAnimation =
      currentSlide.animate(
        [
          {
            opacity: 1
          },
          {
            opacity: 0
          }
        ],
        {
          duration: TRANSITION_DURATION,
          easing: TRANSITION_EASING,
          fill: 'forwards'
        }
      );

    var incomingAnimation =
      nextSlide.animate(
        [
          {
            opacity: 0
          },
          {
            opacity: 1
          }
        ],
        {
          duration: TRANSITION_DURATION,
          easing: TRANSITION_EASING,
          fill: 'forwards'
        }
      );

    slider._misqaAnimations = [
      outgoingAnimation,
      incomingAnimation
    ];

    Promise.allSettled([
      outgoingAnimation.finished,
      incomingAnimation.finished
    ]).then(function () {
      if (
        slider.dataset
          .transitionTarget !==
        String(nextIndex)
      ) {
        return;
      }

      setFinalSlideState(
        slider,
        slides,
        nextIndex
      );
    });
  }

  function initialiseCards(root) {
    var scope = root || document;

    var cards =
      scope.querySelectorAll
        ? scope.querySelectorAll(
            '[data-misqa-product-card]'
          )
        : [];

    cards.forEach(function (card) {
      var slider = getSlider(card);
      var slides = getSlides(card);

      if (!slider || !slides.length) {
        return;
      }

      /*
       * Always start from the default
       * first product image.
       */
      slider.dataset.currentIndex = '0';
      slider.dataset.visibleIndex = '0';

      setFinalSlideState(
        slider,
        slides,
        0
      );
    });
  }

  /*
   * Previous/Next image arrows
   * and quantity buttons.
   */
  document.addEventListener(
    'click',
    function (event) {
      var arrow = getClosest(
        event.target,
        '.misqa-card__image-arrow'
      );

      if (arrow) {
        var card = getCard(arrow);
        var slider = getSlider(card);
        var slides = getSlides(card);

        if (
          !card ||
          !slider ||
          slides.length < 2
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        /*
         * Important fix:
         *
         * Calculate Previous/Next from the
         * image currently visible on screen.
         *
         * This fixes the first-click issue
         * when hover has already previewed
         * the second image.
         */
        var visibleIndex =
          getVisibleIndex(
            slider,
            slides
          );

        var direction =
          arrow.classList.contains(
            'misqa-card__image-arrow--prev'
          )
            ? -1
            : 1;

        showImage(
          card,
          visibleIndex + direction,
          true
        );

        return;
      }

      /*
       * Quantity buttons.
       */
      var quantityButton = getClosest(
        event.target,
        '.misqa-card__qty-btn'
      );

      if (!quantityButton) return;

      var quantityCard =
        getCard(quantityButton) ||
        getClosest(
          quantityButton,
          '.misqa-card'
        );

      if (!quantityCard) return;

      var input =
        quantityCard.querySelector(
          '.misqa-card__qty-input'
        );

      var hiddenInput =
        quantityCard.querySelector(
          '.cart-qty'
        );

      if (!input) return;

      event.preventDefault();

      var min = parseInt(
        input.min || '1',
        10
      );

      var max = parseInt(
        input.max || '99',
        10
      );

      var value = parseInt(
        input.value || String(min),
        10
      );

      if (
        quantityButton.classList.contains(
          'increase'
        )
      ) {
        value = Math.min(
          value + 1,
          max
        );
      } else if (
        quantityButton.classList.contains(
          'decrease'
        )
      ) {
        value = Math.max(
          value - 1,
          min
        );
      }

      input.value = String(value);

      if (hiddenInput) {
        hiddenInput.value =
          String(value);

        hiddenInput.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    }
  );

  /*
   * Card hover:
   *
   * Hover previews the image after the
   * currently selected image.
   */
  document.addEventListener(
    'mouseover',
    function (event) {
      if (!hoverQuery.matches) return;

      var card = getCard(event.target);

      /*
       * Do not run again when moving between
       * elements inside the same card.
       */
      if (
        !card ||
        (
          event.relatedTarget &&
          card.contains(
            event.relatedTarget
          )
        )
      ) {
        return;
      }

      var slider = getSlider(card);
      var slides = getSlides(card);

      if (
        !slider ||
        slides.length < 2
      ) {
        return;
      }

      var selectedIndex = parseInt(
        slider.dataset.currentIndex ||
          '0',
        10
      );

      var previewIndex =
        normaliseIndex(
          selectedIndex + 1,
          slides.length
        );

      /*
       * false means hover preview does not
       * permanently update currentIndex.
       */
      showImage(
        card,
        previewIndex,
        false
      );
    }
  );

  /*
   * Mouse leave:
   *
   * Always return to the default first
   * product image.
   */
  document.addEventListener(
    'mouseout',
    function (event) {
      if (!hoverQuery.matches) return;

      var card = getCard(event.target);

      /*
       * Only reset when the mouse leaves
       * the complete product card.
       */
      if (
        !card ||
        (
          event.relatedTarget &&
          card.contains(
            event.relatedTarget
          )
        )
      ) {
        return;
      }

      var slider = getSlider(card);
      var slides = getSlides(card);

      if (!slider || !slides.length) {
        return;
      }

      slider.dataset.currentIndex = '0';

      showImage(
        card,
        0,
        true
      );
    }
  );

  /*
   * Reinitialize cards when Shopify reloads
   * a section inside the Theme Customizer.
   */
  document.addEventListener(
    'shopify:section:load',
    function (event) {
      initialiseCards(event.target);
    }
  );

  window.MisqaProductCard = {
    init: initialiseCards,
    showImage: showImage
  };

  initialiseCards(document);
})();